module.exports = __webpack_public_path__ + "img/climas_old.e88b80c0.png";